export default function CashControl() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M16.0831 7.0514V11.3431C16.0831 13.9098 14.6165 15.0097 12.4165 15.0097H5.09147C4.71647 15.0097 4.35813 14.9764 4.0248 14.9014C3.81647 14.8681 3.61647 14.8098 3.43314 14.7431C2.18314 14.2764 1.4248 13.1931 1.4248 11.3431V7.0514C1.4248 4.48474 2.89147 3.38477 5.09147 3.38477H12.4165C14.2831 3.38477 15.6248 4.17643 15.9831 5.98476C16.0415 6.31809 16.0831 6.65973 16.0831 7.0514Z"
        fill="currentColor"
      />
      <path
        d="M18.5832 9.55102V13.8427C18.5832 16.4094 17.1166 17.5093 14.9166 17.5093H7.59157C6.9749 17.5093 6.41658 17.426 5.93324 17.2427C4.94158 16.876 4.26657 16.1177 4.0249 14.9011C4.35824 14.9761 4.71657 15.0093 5.09157 15.0093H12.4166C14.6166 15.0093 16.0832 13.9094 16.0832 11.3427V7.05102C16.0832 6.65935 16.0499 6.30937 15.9832 5.98438C17.5666 6.31771 18.5832 7.43435 18.5832 9.55102Z"
        fill="currentColor"
      />
      <path
        d="M8.74982 11.402C9.96484 11.402 10.9498 10.417 10.9498 9.20197C10.9498 7.98694 9.96484 7.00195 8.74982 7.00195C7.53479 7.00195 6.5498 7.98694 6.5498 9.20197C6.5498 10.417 7.53479 11.402 8.74982 11.402Z"
        fill="currentColor"
      />
      <path
        d="M3.9834 7.32617C3.64173 7.32617 3.3584 7.60951 3.3584 7.95117V10.4512C3.3584 10.7928 3.64173 11.0762 3.9834 11.0762C4.32506 11.0762 4.6084 10.7928 4.6084 10.4512V7.95117C4.6084 7.60951 4.3334 7.32617 3.9834 7.32617Z"
        fill="currentColor"
      />
      <path
        d="M13.5083 7.32617C13.1666 7.32617 12.8833 7.60951 12.8833 7.95117V10.4512C12.8833 10.7928 13.1666 11.0762 13.5083 11.0762C13.85 11.0762 14.1333 10.7928 14.1333 10.4512V7.95117C14.1333 7.60951 13.8583 7.32617 13.5083 7.32617Z"
        fill="currentColor"
      />
    </svg>
  );
}
